
(function() {
    'use strict';

    var tabTab = function($document, $templateCache, i18nService, ajaxCall, xmsNotificationFactory) {

        var accessShortcut = function() {
            var shortcut = '';
            if (cssua.ua) {
                if(cssua.ua.desktop == 'windows') {
                    if(cssua.ua.chrome || cssua.ua.ie || cssua.ua.safari) {
                        shortcut = 'alt+';
                    }
                    if(cssua.ua.firefox) {
                        shortcut = 'alt+shift+';
                    }
                } else if (cssua.ua.desktop == 'mcintosh'){
                    if(cssua.ua.firefox || cssua.ua.safari || cssua.ua.chrome || cssua.ua.opera) {
                        shortcut = "ctrl+opt+";
                    }
                }
            }
            return shortcut;
        }

        var isSidebar = function(){
            var sidebar = $document.find('.sidebar');
            if(sidebar.length) {
                return sidebar;
            }
            sidebar = $document.find('.lhsNav');
            if(sidebar.length) {
                return sidebar;
            }
            return false;
        }

        return {
            scope:{
                a11yGuideLink: '@',
                advancedCandidateLink: '@',
                searchString: '@',
                advancedManagerLink: '@'
            },
            restrict: "E",
            replace: true,
            transclude: false,
            template: $templateCache.get('components/layout/tabTab.html'),
            // templateUrl: ANGULAR_APP_PATH + 'components/layout/tabTab.html',
            link: function(scope, element, attrs) {

                scope.i18nService = i18nService.preLoadI18nValues({
                    'keyboardShortcuts.mainContent.label': 'Main Content',
                    'keyboardShortcuts.mainNav.label': 'Main Menu',
                    'keyboardShortcuts.sidebar.label': 'Sidebar',
                    'keyboardShortcuts.actionsMenu.label': 'Actions Menu',
                    'keyboardShortcuts.globalSearch.label': 'Global Search',
                    'keyboardShortcuts.advancedCandidateSearch.label': 'Advanced Candidate Search',
                    'keyboardShortcuts.advancedManagerSearch.label': 'Advanced Manager Search',
                    'keyboardShortcuts.advancedSearchMenu.label': 'Advanced Search Menu',
                    'keyboardShortcuts.keyboardShortcuts.label': 'Keyboard Shortcuts',
                    'keyboardShortcuts.nextItem.label': 'Next Item',
                    'keyboardShortcuts.previousItem.label': 'Previous Item',
                    'keyboardShortcuts.scrollToTop.label': 'Scroll To Top',
                    'keyboardShortcuts.highContrast.label': 'High Contrast',
                    'keyboardShortcuts.accessibilityGuide.label': 'Accessibility Guide'
                });

                const keys = {
                    arrowRight: 39,
                    arrowLeft: 37,
                    num0: 96,
                    num1: 97,
                    num2: 98
                };

                scope.shortcut = accessShortcut();
                scope.shortcutsModel = {};
                scope.shortcutsModel.shortcut = scope.shortcut;
                scope.sidebar = isSidebar();
                scope.webPath = WEBAPP_PATH;

                // Enable right / left & num left / num right arrow key triggers for view cv navigation
                document.onkeydown = checkKey;

                function checkKey(e) {
                    if (e.keyCode == keys.arrowLeft) {
                        scope.previousItem();
                    } else if (e.keyCode == keys.arrowRight) {
                        scope.nextItem();
                    } else if (e.altKey && e.which == keys.num0) {
                        scope.openShortcutsModel();
                    } else if (e.altKey && e.which == keys.num1) {
                        scope.focusNav();
                    } else if (e.altKey && e.which == keys.num2) {
                        scope.focusSidebar();
                    }
                }

                scope.focusMain = function(){
                    if( $document.find('.main').length ) {
                        $document.find('.main').focus();
                    } else if( $document.find('.home').length ) {
                        $document.find('.home').focus();
                    }
                    $('html,body').scrollTop(0);
                };
                scope.focusNav = function(){
                    $document.find('.pageHead nav').focus();
                };
                scope.focusSearch = function(){
                    $document.find('.searchBox input.input').focus();
                };
                scope.focusSidebar = function(){
                    scope.sidebar.focus();
                    $('html,body').scrollTop(0);
                };
                scope.scrollTop = function() {
                    clickElement('.back-to-top');
                };
                scope.openActions = function(){
                    clickElement('.action-box button');
                };
                scope.nextItem = function(){
                    clickElement('.shortcut-next-item');
                };
                scope.previousItem = function(){
                    clickElement('.shortcut-previous-item');
                };
                scope.openAdvancedSearch = function() {
                    clickElement('#advSearchMenuButton');
                };
                scope.openShortcutsModel = function() {
                    clickElement('#shortcuts-modal');
                };
                scope.goToLink = function(link) {
                    window.location = link;
                };

                scope.goToCandidateLink = function() {
                    if(scope.searchString.length > 0){
                        var ajaxUrl = WEBAPP_PATH + '/advancedSearch/getAdvancedCandidateLink?searchTerm='+scope.searchString;
                        ajaxCall.getData(ajaxUrl).then(
                            function(result) {
                                window.location = result.data;
                            },
                            function(result) {
                                var errorMessage = "Error: " + result.status + ' on  Advanced Candidate Search shortcut';
                                xmsNotificationFactory.add('goToCandidateLinkErrorMessage', 'warning', errorMessage , 5);
                            }
                        );
                    }else{
                        window.location = scope.advancedCandidateLink;
                    }
                };

                scope.goToManagerLink = function() {
                    if(scope.searchString.length > 0){
                        var ajaxUrl = WEBAPP_PATH + '/advancedSearch/getAdvancedManagerLink?searchTerm='+scope.searchString;
                        ajaxCall.getData(ajaxUrl).then(
                            function(result) {
                                window.location = result.data;
                            },
                            function(result) {
                                var errorMessage = "Error: " + result.status + ' on  Advanced Manager Search shortcut';
                                xmsNotificationFactory.add('goToManagerLinkErrorMessage', 'warning', errorMessage , 5);
                            }
                        );
                    }else{
                        window.location = scope.advancedManagerLink;
                    }
                };

                function clickElement(target) {
                    setTimeout(function(){
                        $document.find(target).triggerHandler('click');
                    }, 0);
                }
            }

        };
    }
    tabTab.$inject = ['$document', '$templateCache', 'i18nService', 'ajaxCall', 'xmsNotificationFactory'];
    angular.module('app').directive('tabTab', tabTab);

}());